import ClipLoader from 'react-spinners/ClipLoader';

export default ClipLoader;
